<div class="input-group" style="flex-wrap: nowrap;">
    <div class="input-group-text cls-du-height-search" id="btnGroupAddon">
        <select class="du-header-search-dropdown" [(ngModel)]="selectedSearchByKey"
            (change)="findSearchBySelectedName(selectedSearchByKey)">
            <option *ngFor="let data of searchByKey;" [value]="data.value">{{data.name}}</option>
        </select>
    </div>
    <input type="search" class="form-control du-header-search-input cls-du-height-search"
        [(ngModel)]="serverSideSearchFilterText" [placeholder]="'Search by '+ searchBySelectedName?.name"
        aria-label="Search by" aria-describedby="btnGroupAddon" (keydown.enter)="serverSideSearch()"
        (input)="serverSideSearchClose($event)">
    <div class="input-group-text cls-du-height-search" id="btnGroupAddon">
        <span class="mat-search-box-du" (click)="serverSideSearch()">
            <svg width="13" height="13" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.33333 11.6667C9.27885 11.6667 11.6667 9.27885 11.6667 6.33333C11.6667 3.38781 9.27885 1 6.33333 1C3.38781 1 1 3.38781 1 6.33333C1 9.27885 3.38781 11.6667 6.33333 11.6667Z"
                    stroke="#101d42" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.3333 10.334L13 13.0007" stroke="#101d42" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </span>
    </div>
</div>